<script>
    import registrationTypes from '../config/registrationTypes';

    import FormRow from './FormRow.svelte';
    import FormColumn from './FormColumn.svelte';
    import ClaimantSomeoneElse from './ClaimantSomeoneElse.svelte';
    import ClaimantCompany from './ClaimantCompany.svelte';
    import ClaimantTrust from './ClaimantTrust.svelte';

    export let disabled = null;
    export let required;
    export let companyDetailRequired = null;

    export let registrationType;
    export let claimants;
    export let registration;
    export let contactFirstName;
	export let contactSurname;
    

    if (registrationType == registrationTypes.types.Company.name){
        if (claimants){
            claimants[0].firstName = "";
        }
    }

    if (companyDetailRequired == null){
        companyDetailRequired = required;
    }

</script>

<FormRow>
    <FormColumn>
        <h2>Claimant Details</h2>
        <p>
            The person you enter in the fields below will be recorded as the claimant in this action, 
            unless this person is an agent, trustee, director or authorised signatory of the claimant.
        </p>
    </FormColumn>
</FormRow>

{#if registrationType == registrationTypes.types.SomeoneElse.value}
    <ClaimantSomeoneElse {disabled} bind:claimants bind:registration/>
{:else if registrationType == registrationTypes.types.Company.name}
    <ClaimantCompany 
        bind:name={claimants[0].surname}
        bind:nzbn={registration.nzbn}
        bind:capacityId={registration.capacityId}
        bind:authorisedToAct={registration.authorisedToAct}
        {disabled}
        required={companyDetailRequired}></ClaimantCompany>
{:else if registrationType == registrationTypes.types.Trust.name}
    <ClaimantTrust 
        bind:trustName={claimants[0].surname}
        bind:trustees={registration.trustees}
        bind:contactIsTrustee={registration.contactIsTrustee}
        bind:authorisedToAct={registration.authorisedToAct}
        {contactFirstName}
	    {contactSurname}
        {disabled}></ClaimantTrust>
{/if}

<style></style>